import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { message } from "antd";
import {
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
} from "../../redux/actions/cartActions";
import { hideSideBar } from "../../redux/actions/miscActions";

export class Cart extends Component {
  handleDecreaseQuantity = (x) => {
    const { uid } = this.props.user.user;
    if (x.quantity === 1) {
      this.warning();
    } else {
      this.props.decreaseQuantity(x, uid);
    }
  };

  handleIncreaseQuantity = (x) => {
    const { uid } = this.props.user.user;
    this.props.increaseQuantity(x, uid);
  };

  handleDelete = (id) => {
    const { uid } = this.props.user.user;
    this.props.removeFromCart(id, uid);
  };

  goToCheckout = () => {
    this.props.hideSideBar();
    this.props.history.push("/checkout");
  };

  warning = () => {
    message.warning("Het aantal mag niet minder dan 1 zijn");
  };

  render() {
    const { cart } = this.props.cart;
    const { products, pakketten } = this.props.products;

    const allItems = [...products, ...pakketten];
    const cats = ["groenten", "fruit", "sap", "aardvrucht", "specerijen"];

    let cartArray = [];
    for (const property in cart) {
      if (property !== "owner" && property !== "store") {
        cartArray.push(cart[property]);
      }
    }

    const cartItems = cartArray.map((x) => {
      return x;
    });
    let shoppingCart = [];
    for (let i = 0; i < cartItems.length; i++) {
      const cartItem = allItems.filter((x) => x.id === cartItems[i].id)[0];
      if (cartItem === undefined) {
        continue;
      }
      const itemQuantity = cartItems.filter((x) => x.id === cartItem.id)[0]
        .quantity;
      const newCartItem = [{ ...cartItem, quantity: itemQuantity }];
      shoppingCart.push(...newCartItem);
    }

    const cartList = shoppingCart
      .sort((a, b) =>
        a.productNaam > b.productNaam
          ? 1
          : b.productNaam > a.productNaam
          ? -1
          : 0
      )
      .map((x) => (
        <div className="cart-item" key={x.id}>
          <div className="cart-image">
            {cats.includes(x.productCategorie.toString()) && x.productOnSale ? (
              <span className="on-sale-tag">SALE</span>
            ) : null}
            <img src={x.productImage} alt="" />
          </div>
          <div className="item-details">
            <div className="cart-name">
              <p>
                {x.productCategorie === "pakket" ? x.pakketNaam : x.productNaam}
              </p>
            </div>
            <div className="product-price">
              <p>
                {x.productOnSale
                  ? new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: "SRD",
                    }).format(`${x.itemSalesPrice}`)
                  : new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: "SRD",
                    }).format(`${x.itemPrice}`)}
              </p>
            </div>
            <div className="quantity">
              <i
                className="fas fa-minus-square"
                onClick={() =>
                  this.handleDecreaseQuantity(
                    cartArray.filter((y) => y.id === x.id)[0]
                  )
                }
              ></i>
              {x.quantity} x {x.productEenheid}
              <i
                className="fas fa-plus-square"
                onClick={() =>
                  this.handleIncreaseQuantity(
                    cartArray.filter((y) => y.id === x.id)[0]
                  )
                }
              ></i>
            </div>
            <div className="price">
              <p>
                {x.productOnSale
                  ? new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: "SRD",
                    }).format(`${x.itemSalesPrice * x.quantity}`)
                  : new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: "SRD",
                    }).format(`${x.itemPrice * x.quantity}`)}
              </p>
            </div>
          </div>
          <div
            className="remove-button"
            onClick={() => this.handleDelete(x.id)}
          >
            <i className="fas fa-trash"></i>
          </div>
        </div>
      ));
    return (
      <div className="cart">
        <p className="cart-header">Uw winkelwagen</p>
        <div className="cart-list">
          {cartList.length > 0 ? (
            cartList
          ) : (
            <p className="empty-cart">Uw winkelwagen is leeg</p>
          )}
          <p className="extra-info">
            Bestellingen die maandag t / m vrijdag voor 9 uur zijn geplaatst,
            worden dezelfde dag nog geleverd.
          </p>
        </div>
        {cartList.length > 0 ? (
          <button className="checkout" onClick={this.goToCheckout}>
            Checkout
          </button>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  products: state.products,
  user: state.user,
});

export default connect(mapStateToProps, {
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  hideSideBar,
})(withRouter(Cart));
